import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@desktop/store'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: '',
  timeout: 300000
})

service.interceptors.request.use(config => {
  /*if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }*/
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})
service.interceptors.response.use(
  response => {
    const res = response.data
    const statusCode = String(res.errorCode);
    if (statusCode !== '200') {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      if (statusCode === '406') {
        MessageBox.confirm('您的登录已失效，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('LoginOut').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js